<mat-toolbar class="nav-bar">
  <div class="content"  fxLayout="row" fxLayoutAlign="end center">
    <ng-content></ng-content>
  </div>
</mat-toolbar>
